export const ACCESS_TOKEN_NAME = 'accessToken';
export const REFRESH_TOKEN_NAME = 'refreshToken';
export const USER_KEY_NAME = 'admin_user';

export const TOKEN_ERROR_CAUSES = {
    ACCESS_EXPIRED: 'ACCESS_TOKEN_EXPIRED',
    REFRESH_EXPIRED: 'REFRESH_TOKEN_EXPIRED',
    INVALID: 'INVALID_TOKEN',
};

export const setAuthTokens = (accessToken, refreshToken) => {
    if (accessToken) {
        localStorage.setItem(ACCESS_TOKEN_NAME, accessToken);
    }
    if (refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_NAME, refreshToken);
    }
};

let hasShownLogoutWarning = false;
export const clearAuth = () => {
    if (!hasShownLogoutWarning) {
        alert('Sua sessão expirou. Por favor, faça login novamente.');
        hasShownLogoutWarning = true;
    }
    localStorage.removeItem(USER_KEY_NAME);
    localStorage.removeItem(ACCESS_TOKEN_NAME);
    localStorage.removeItem(REFRESH_TOKEN_NAME);
    window.location.href = '/';
};

// Build headers with Authorization token
export const getAuthHeaders = () => {
    const accessToken = localStorage.getItem(ACCESS_TOKEN_NAME);
    if (accessToken) {
        return { Authorization: `Bearer ${accessToken}` };
    }
    return {};
};

// Refresh tokens
let isRefreshing = false;
let refreshSubscribers = [];

const onRefreshed = (newToken) => {
    for (const callback of refreshSubscribers) {
        callback(newToken);
    }
    refreshSubscribers = [];
};
export const refreshAuthTokens = async () => {
    if (isRefreshing) {
        return new Promise((resolve) => {
            refreshSubscribers.push(resolve);
        });
    }

    isRefreshing = true;

    try {
        const refreshToken = localStorage.getItem(REFRESH_TOKEN_NAME);

        if (!refreshToken) {
            console.error('No refresh token available');
            clearAuth();
            return;
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/user/refresh-token`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ refreshToken }),
        });

        if (!response.ok) {
            console.error('Refresh token expired');
            clearAuth();
            return;
        }

        const data = await response.json();
        setAuthTokens(data.accessToken, data.refreshToken);

        isRefreshing = false;
        onRefreshed(data.accessToken);
        return data.accessToken;
    } catch (error) {
        isRefreshing = false;
        refreshSubscribers = [];
        throw error;
    }
};

export const checkTokenError = async (error, retryCount, requestCallback) => {
    if (error?.cause === TOKEN_ERROR_CAUSES.ACCESS_EXPIRED && retryCount < 1 && requestCallback) {
        await refreshAuthTokens();
        return requestCallback();
    }

    if (error?.cause === TOKEN_ERROR_CAUSES.INVALID || error?.error === TOKEN_ERROR_CAUSES.INVALID) {
        clearAuth();
        return;
    }

    // Re-throw the error if it's not a token-related issue
    throw error;
};
